export function shouldUseFrontEndServerTranslations(): boolean {
	return (
		process.env.NODE_ENV === 'production' ||
		!!process.env.DEV_USE_SERVER_TRANSLATIONS ||
		// in ALLOW_LOCAL_IP mode the browser origin is no longer a *.local-change.org host, so the
		// cross-origin S3 fetch for non-en-US locales fails CORS; routing through the same-origin
		// front-end proxy (/corgi/i18n/) avoids it
		!!process.env.ALLOW_LOCAL_IP
	);
}

/**
 * Whether the in-bundle en-US (BASE_LOCALE) translations should be used instead of fetching them.
 *
 * This is a dev-only shortcut and is intentionally independent of ALLOW_LOCAL_IP: en-US stays
 * bundled even in that mode, so only non-en-US locales go through the dev-server proxy.
 */
export function shouldUseBundledBaseLocale(): boolean {
	return process.env.NODE_ENV !== 'production' && !process.env.DEV_USE_SERVER_TRANSLATIONS;
}
